import { render, staticRenderFns } from "./FormItem.vue?vue&type=template&id=b2f7c0ec&"
import script from "./FormItem.vue?vue&type=script&lang=js&"
export * from "./FormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports